




import EventBus from '@/eventBus.js';
import MembershipCreate from '../../../../Templates/Admin/Membership/MembershipCreate/MembershipCreate.vue';

export default {
    name: 'CoMemberPlanCreate',
    components: {
        MembershipCreate,
    },
    data() {
        return {
            userId: this.$route.params.ID,
            userName: '',
        };
    },
    created() {
        this.userName = this.$t('labels.user');
        this.adminGetUserByID(this.userId);
    },
    methods: {
        adminGetUserByID(ID) {
            this.$store
                .dispatch('adminGetUserByID', ID)
                .then((response) => {
                    const user = response;

                    if (user.Profile && user.Profile.Name) {
                        this.userName = user.Profile.Name;
                    }
                })
                .catch((error) => {
                    const message = {
                        Message: this.$t('messages.userDataLoadFailed'),
                        Details: error.response.data,
                    };
                    EventBus.$emit('ERROR', message);
                })
                .finally(() => {
                    this.setBreadcrumbs();
                });
        },
        setBreadcrumbs() {
            this.$store.commit('SET_BREADCRUMBS', [
                {
                    text: this.$t('labels.manage'),
                    to: '/admin',
                },
                {
                    text: this.$t('labels.members'),
                    to: '/admin/community/member/list',
                },
                {
                    text: this.userName,
                    to: `/admin/community/member/view/${this.userId}`,
                },
                {
                    text: this.$t('labels.membershipcreate'),
                },
            ]);
        },
    },
};
